import Project from "../project"
import {toMomentDate} from "../../../gd/convert/moment-date"

export default function projectUpdateStartEndDate(project:Project, startDate:Moment|null, endDate:Moment|null) {
    if (!startDate) {
        project.startDate = null
        project.endDate   = null
        return
    }

    // if endDate BEFORE start set start = end because we update START here
    if (!endDate || endDate.isBefore(startDate,'days')) {
        endDate = toMomentDate(startDate)
    }

    project.startDate = toMomentDate(startDate)
    project.endDate   = toMomentDate(endDate)
}